import React, { useContext, useState } from "react";
import { Form, Input, Button, notification, message } from "antd";
import { MailOutlined, KeyOutlined } from "@ant-design/icons";
import "./style.css";
import logo from "../../../Assets/Images/Logo.png";
import logoDark from "../../../Assets/icons/Sidebaricon/Logo Dark.svg";
import { checkApiKeyValidity, login } from "../../../API/auth";
import { encryptText } from "../../../Utils/Encryption";
import updateUserStates from "../../../Utils/UpdateUsersState";
import { UserContext } from "../../../App";
import { useNavigate, Link } from "react-router-dom";
import { ThemeContext } from "../../../Contexts/ThemeProvider";

const Login = () => {
  const {
    userData,
    setUserData,
    setUserToken,
    setUserPages,
    setUserApiKeyStatus,
  } = useContext(UserContext);
  const { isDarkMode } = useContext(ThemeContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const checkValidation = async () => {
    try {
      const response = await checkApiKeyValidity();
      setUserApiKeyStatus({
        status: response.data.status,
        message: response.data.message,
      });
    } catch (error) {
      message.error("Failed To Check Api Key Status");
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    const { email, password } = values;
    const loginData = await login({ email, password });
    if (loginData?.status === 200) {
      console.log(loginData?.data);

      localStorage.clear();
      localStorage.setItem(
        encryptText("token"),
        encryptText(
          JSON.stringify({
            access: loginData?.data?.access,
            refresh: loginData?.data?.refresh,
          })
        )
      );
      localStorage.setItem(
        encryptText("user"),
        encryptText(
          JSON.stringify({
            id: loginData?.data?.id,
            role: loginData?.data?.role,
            name: loginData?.data?.name,
            email: loginData?.data?.email,
            verified: loginData?.data?.verified,
            profile_picture: loginData?.data?.profile_picture
              ? process.env.REACT_APP_MEDIA_URL +
                loginData?.data?.profile_picture
              : null,
          })
        )
      );

      updateUserStates(setUserData, setUserToken);
      setUserPages(loginData?.data?.pages);
      if (loginData?.data?.verified) {
        navigate("/home");
        if (loginData?.data?.role !== "admin") {
          await checkValidation();
        }
      } else {
        navigate("/verification-link");
      }
    } else {
      notification.error({
        message: "Invalid login details",
        description: "Kindly provide correct email and password",
      });
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="logo">
        <img src={isDarkMode ? logoDark : logo} alt="Company Logo" />
      </div>

      <div className="login">
        <div className="login-card">
          <div className="title">
            <div className="main">Log in to SmartTrack</div>
            <div className="sub">Please enter your credentials</div>
          </div>
          <Form
            name="login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <div className="placeholders-heading">Email Address </div>
            <Form.Item
              name="email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input
                type="email"
                prefix={<MailOutlined className="site-form-item-icon" />}
                placeholder="Enter email"
              />
            </Form.Item>
            <div className="placeholders-heading">Password </div>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please input your Password!" },
              ]}
            >
              <Input.Password
                prefix={<KeyOutlined className="site-form-item-icon" />}
                placeholder="Type Password"
              />
            </Form.Item>
            <div className="login-form-forgot">
              <Link to="/forgot">Forget password?</Link>
            </div>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={loading}
              >
                Log In
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
